<template>
    <div class="wrapper">

        <header v-if="!isPhone">
            <TheHeaderBar :title="'我的退款列表'"/>
        </header>
        <div class="content">
            <div class="address-list" v-if="datas.length > 0">
                <div class="address-item" v-for="item in datas" @click="handleDetail(item.id)">
                    <div class="user-info">
                        <div>
                            <span class="user-name">{{item.name}}</span>
                            <span class="user-tel">{{item.tel}}</span>
                        </div>
                        <div>
                            <span>退款金额：{{item.amount}}元</span>
							<span>&nbsp;&nbsp;{{item.created_at}}</span>
                        </div>
                    </div>
                    <div class="btn" v-if="item.status === 0">待审核</div>
                    <div class="btn" style="color:green;" v-if="item.status === 1">已通过</div>
                    <div class="btn" style="color:red;" v-if="item.status === 2">已拒绝</div>
                </div>
            </div>
            <div v-else class="no-address">
                暂无退款记录
            </div>
        </div>

        <footer class="footer" @click="handleAddAddress">
            <van-button type="danger" size="large">发起退款申请</van-button>
        </footer>
    </div>
</template>

<script>
    import TheHeaderBar from "../../components/base/TheHeaderBar";
    import {mapState} from "vuex";
    import {
        refundListService
    } from '../../service/userService';
    import { Toast,Dialog } from 'vant';
    import {getUrlParamsTools, phoneInteractiveTools} from "../../util/tools";
    import phoneInteractiveData from "../../data/phoneInteractiveData";
	import {wecharShare} from "../../util/weChat.js";

    export default {
        name: "AddressList",
        data(){
            return{
                datas:[],
                lock:false,//是否提示切换地址
                isPhone: false,
                isCart:false,
                phoneState:"IOS",
            }
        },
        mounted() {
           this.getData();
        },
        methods:{
            // 数据获取
            getData(){
                refundListService(this.userId).then(res => {
                    if(res.status === 1){
                        this.datas = res.datas;
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {})
            },

            //编辑我的收货地址
            handleDetail(id){
                this.$router.push({
                    name: 'refundDetail',
                    params:{
                        id:id,
                    }
                })
            },

            //新增我的收货地址
            handleAddAddress(){
                this.$router.push({
                    name: 'addrefund',
                    params:{
                        addressId:0,
                    }
                })
            },
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
            })
        },
        components: {
            TheHeaderBar,
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        header{
            padding-bottom: 46px;
        }
        .content{
            .address-list{
                background: #ffffff;
                padding: 0 10px;
                box-sizing: border-box;
                .address-item{
                    padding: 15px 0;
                    display: flex;
                    margin-bottom: 10px;
					border-bottom: 1px solid #ddd;
                    .address-img{
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        background: #cccccc;
                        flex: 10%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        span{
                            white-space: nowrap;
                            width: 36px;
                            text-align: center;
                            padding: 5px;
                            box-sizing: border-box;
                            overflow: hidden;
                            color: rgb(250,250,250);
                        }
                    }
                    .user-info{
                        margin-left: 10px;
                        flex: 70%;
                        .user-name{
                            font-size: 14px;
                            color: #000000;
                        }
                        .user-tel{
                            margin-left: 10px;
                        }
                        .address-default{
                            color: #f20f20;
                            margin-right: 10px;
                            padding:2px 5px;
                            background: rgb(252,237,230);
                        }
                    }
                    .btn{
                        flex: 20%;
                        border-left: 1px solid rgb(241,241,241);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
            .no-address{
                text-align: center;
                padding: 20px 0;
                span{
                    color: #1871F8;
                }
            }
        }
        .footer{
            position: fixed;
            bottom: 0;
            width: 100%;
        }
    }
</style>